import React from "react";
export const regulations = () => {
  return (
    <div className="opinion-wrap">
      <h1>信访事项的办理期限是如何规定的？</h1>
      <div className="text-cont">
        &nbsp; &nbsp; &nbsp; &nbsp;根据《信访工作条例》的有关规定，信访部门收到信访事项后，区分情况在15日内转送、交办有权处理的单位、部门，或告知不予（不再）受理；有权处理的单位、部门应当自收到信访事项之日起15日内书面告知接收情况及处理途径和程序；对不属于本单位或者本部门职权范围的，有关单位、部门应当自收到之日起5个工作日内提出异议，交还相关材料；依据《信访工作条例》第二十九、三十、三十一条规定，信访事项由有权处理的单位、部门区分情况办理，其中属于《信访工作条例》第三十一条第六项规定的信访事项，自受理之日起60日内办结；情况复杂的，延期30日办结。
      </div>
      <br />
    </div>
  );
};
